import React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { useDrawingArea } from '@mui/x-charts/hooks';
import { styled } from '@mui/material/styles';

export interface ImpactDonutCompactProps {
  budget: number;
  defundedAmount: number;
}

const CenterText = styled('text')(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: 'middle',
  dominantBaseline: 'central',
  fontWeight: 600,
}));

function PieCenterLabel({ percentCutText }: { percentCutText: string }) {
  const { width, height, left, top } = useDrawingArea();
  const cx = left + width / 2;
  const cy = top + height / 2;

  return (
    <CenterText x={cx} y={cy} style={{ fontSize: 14 }}>
      {percentCutText} Needed
    </CenterText>
  );
}

export const ImpactDonutCompact = ({
  budget,
  defundedAmount,
}: ImpactDonutCompactProps): React.JSX.Element | null => {
  if (budget && budget > 0 && defundedAmount && defundedAmount > 0 && budget >= defundedAmount) {
    const rawPct = budget > 0 ? Math.round((defundedAmount / budget) * 100) : 0;
    const percentCutText = rawPct >= 1 ? `${Math.round(rawPct)}%` : `${rawPct.toFixed(1)}%`;

    return (
      <PieChart
        width={120}
        height={120}
        hideLegend={true}
        series={[
          {
            innerRadius: 42,
            outerRadius: 50,
            data: [
              {
                id: 0,
                color: '#2CAEC9',
                value: budget - defundedAmount,
                label: 'Budget',
              },
              {
                id: 1,
                color: '#E65222',
                value: defundedAmount,
                label: 'Defunded',
              },
            ],
          },
        ]}
      >
        <PieCenterLabel percentCutText={percentCutText} />
      </PieChart>
    );
  } else {
    return null;
  }
};
